class Plot{
    constructor(id,name,fillColor,strokeColor,polygon,cropsland,acre=0){
       this.id = id 
       this.name = name;
       this.fillColor = fillColor;
       this.strokeColor = strokeColor;
       this.polygon = polygon;
       this.acre = acre
       this.cropsland = cropsland; //array[]
    }
}

export default Plot